import React from 'react';
import { Link } from 'react-router-dom';
import { ROAVYN_POWERED_BADGE } from '../common/roavynAssets';

export default function Footer({ admin = false }) {
  return (
    <footer>
      <span className="footer-product">
        <img
          className="powered-by-roavyn"
          src={ROAVYN_POWERED_BADGE}
          alt="Powered by Roavyn"
        />
        <span>Roavyn SOSBooking</span>
      </span>
      <span className="footer-right">
        {!admin && <Link to="/admin-login">Guide Admin</Link>}
        {admin && <Link to="/book">Customer Booking</Link>}
      </span>
    </footer>
  );
}